import { css } from '@emotion/react';
import { semanticTokens, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { formatCurrency } from 'shared';

const styles = {
  lineItem: (total?: boolean) => css`
    display: flex;
    justify-content: space-between;
    & > dt,
    & > dd {
      font-size: ${total ? tokens.fontSize.heading['title-2'] : tokens.fontSize.paragraph['paragraph-2']};
      color: ${semanticTokens.color.text.primary};
      ${total && `font-weight: 700;`}
    }
  `,
  breakdownContainer: css`
    dl {
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: ${tokens.dimension['space-6']};
    }
  `,
};

export type TaxBreakdownRow = {
  label: string;
  price: number;
};

type TaxBreakdownProps = {
  rows: TaxBreakdownRow[];
  pos: string;
};

export const TaxBreakdown = ({ rows, pos }: TaxBreakdownProps) => {
  const total = rows.reduce((acc, { price }) => acc + price, 0);

  const LineItem = ({ label, price, total }: { label: string; price: number; total?: boolean }) => (
    <div key={label} css={styles.lineItem(total)}>
      <dt dangerouslySetInnerHTML={{ __html: label }}></dt>
      <dd>{formatCurrency(price, pos)}</dd>
    </div>
  );

  return (
    <div css={styles.breakdownContainer}>
      <dl>
        {rows.map(({ label, price }) => (
          <LineItem key={label} label={label} price={price} />
        ))}
        <LineItem total label={t('common:total')} price={total} />
      </dl>
    </div>
  );
};
